import React, { useMemo } from 'react';

import { parseReceivedNotifications } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import InfoBox from 'containers/distributors/distributor-details/InfoBox';
import { MessageGroup } from 'components';

const MessagesSection = ({ user }) => {
    const receivedMessages = useMemo(
        () => parseReceivedNotifications(user?.receivedNotifications),
        [user]
    );
    return (
        <InfoBox title={texts.MESSAGES} disableLeftColumn>
            <MessageGroup messages={receivedMessages} />
        </InfoBox>
    );
};

export default React.memo(MessagesSection);
